export enum FilterTypeEnum {
  DATE = 'date',
  REALTIME = 'realtime',
  REGULAR = 'regular'
}
